import React, { useState } from 'react';
import { ReactSVG } from 'react-svg';
import warning from '../../assets/image/warning.svg';

const NotificationAlert = ({ text }) => {
  const [visible] = useState(true);
  return (
    <div className="notification-container">
      {visible && (
        <div className="alert-box">
          <span className="alert-icon"><ReactSVG src={warning} /></span>
          <p className="alert-text">
            {text}
          </p>
        </div>
      )}
    </div>
  );
};
export default NotificationAlert;
